/**
 * Apcam.Api.Web
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Enum for SendGrid marketing list entry type.
 */
export const SendGridListType = {
    DropOut: 1,
    Client: 2
} as const;
export type SendGridListType = typeof SendGridListType[keyof typeof SendGridListType];

